class Countries {
  constructor({ id = "", name = "" }) {
    this.value = id;
    this.title = name;
  }
}

export default Countries;
